export default "__VITE_ASSET__DS7HGOsb__"